// Site-wide SEO data: used by <Seo/> at runtime and by scripts/prerender.js at build time.
import { CONTACT_EMAIL, FOUNDER_NAME, LINKEDIN_URL } from "./site";

export const SITE_URL = "https://enchantetravel.com";
export const SITE_NAME = "Enchanté";
export const FOUNDER_SITE_URL = "https://latifa-alkhalifa.com";

export const HOME_TITLE = "Enchanté | Art Fair Travel Advisory";
export const HOME_DESCRIPTION =
  "Art fair travel advisory for galleries and collectors across the Arab world. Frieze Abu Dhabi, Art Basel Qatar, 1-54 Marrakech, Art Dubai.";

// Former inner pages: hidden from the public and search engines, each redirects to the homepage.
export const RETIRED_PATHS = [
  "/frieze-abu-dhabi",
  "/art-basel-qatar",
  "/1-54-marrakech",
  "/art-dubai",
  "/services",
  "/about",
  "/faq",
  "/contact",
];

const organizationSchema = () => ({
  "@type": ["TravelAgency", "Organization"],
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/og/logo.png`,
  image: `${SITE_URL}/og/home.jpg`,
  description: HOME_DESCRIPTION,
  email: CONTACT_EMAIL,
  areaServed: ["United Arab Emirates", "Qatar", "Saudi Arabia", "Morocco", "Bahrain"].map((name) => ({ "@type": "Country", name })),
  knowsLanguage: ["en", "ar"],
  founder: { "@id": `${SITE_URL}/#person` },
  sameAs: [LINKEDIN_URL],
});

const personSchema = () => ({
  "@type": "Person",
  "@id": `${SITE_URL}/#person`,
  name: FOUNDER_NAME,
  jobTitle: "Curator and Founder, Enchanté",
  nationality: { "@type": "Country", name: "Bahrain" },
  knowsLanguage: ["Arabic", "English"],
  alumniOf: { "@type": "CollegeOrUniversity", name: "King's College London" },
  worksFor: { "@id": `${SITE_URL}/#organization` },
  url: `${SITE_URL}/`,
  sameAs: [FOUNDER_SITE_URL, LINKEDIN_URL],
});

export function seoForPath(path) {
  if (path !== "/") return null;
  return {
    path,
    title: HOME_TITLE,
    description: HOME_DESCRIPTION,
    image: `${SITE_URL}/og/home.jpg`,
    imageAlt: "Enchanté — Art Fair Travel Advisory",
    type: "website",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        organizationSchema(),
        personSchema(),
        { "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` }] },
      ],
    },
  };
}
